import React from 'react';
import PropTypes from 'prop-types';
import {CrossIconOld} from '../../icons/cross-icon';
import {Container, ContentContainer, TextContainer, IconContainer, Text, Title} from './badge.styled';

export const Badge = ({title, text, maxWidth, onRemoveClick, disabled, tooltip}) => {
	const handleRemoveClick = () => {
		onRemoveClick();
	};

	return (
		<Container maxWidth={maxWidth} disabled={disabled}>
			<ContentContainer>
				<TextContainer>
					<Title title={title}>{title}</Title>
					<Text title={tooltip ?? text}>{text}</Text>
				</TextContainer>
				{onRemoveClick && (
					<IconContainer onClick={handleRemoveClick}>
						<CrossIconOld color={disabled ? '#535353' : '#fff'} />
					</IconContainer>
				)}
			</ContentContainer>
		</Container>
	);
};

Badge.propTypes = {
	/**
	 * Top text of the badge
	 */
	title: PropTypes.string.isRequired,
	/**
	 * Content text
	 */
	text: PropTypes.string.isRequired,
	/**
	 * Adjust the max width the badge will grow too
	 */
	maxWidth: PropTypes.number,
	/**
	 * Handler for onRemove, will also enable the cross icon
	 */
	onRemoveClick: PropTypes.func,
	/**
	 * Gray out card to show its disabled
	 */
	disabled: PropTypes.bool,
	/**
	 * Hover text for the content, defaults to the content text
	 */
	tooltip: PropTypes.string,
};

Badge.defaultProps = {
	maxWidth: 130,
};
